var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.hideMe),expression:"hideMe"}],staticClass:"aside-menu"},[_vm._t("default",[_vm._v("Aside")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }